'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _profileHeader = require('./profile-header');

var _profileHeader2 = _interopRequireDefault(_profileHeader);

var _specialistProfileHeader = require('../../src/styles/specialist-profile-header.scss');

var _specialistProfileHeader2 = _interopRequireDefault(_specialistProfileHeader);

var _specialist = require('../../src/img/specialist.png');

var _specialist2 = _interopRequireDefault(_specialist);

var _specialistBg = require('../../src/img/specialist-bg.png');

var _specialistBg2 = _interopRequireDefault(_specialistBg);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecialistProfileHeader = function SpecialistProfileHeader(props) {
	return _react2.default.createElement(
		_profileHeader2.default,
		{
			type: 'specialist',
			name: props.name,
			qualifications: props.qualifications,
			specialty: props.specialty,
			profileImage: props.profileImage,
			profileImageBackground: _specialistBg2.default,
			specialtyIcon: props.specialtyIcon,
			averageRating: props.averageRating,
			totalReviews: props.totalReviews,
			onStarsClick: props.onStarsClick,
			onAddReview: props.onAddReview,
			className: props.className,
			isCore: props.isCore,
			isAHG: props.isAHG,
			videoConsultation: props.videoConsultation,
			networks: props.networks
		},
		(props.onRequestAppointment || props.onShowPhoneNumbers) && _react2.default.createElement(
			'div',
			{ id: _specialistProfileHeader2.default.actions },
			props.onRequestAppointment && _react2.default.createElement(
				'button',
				{ className: _specialistProfileHeader2.default.solid,
					onClick: function onClick() {
						props.onRequestAppointment();
						(0, _doctifyUtils.fireGTMevent)('patient_lead_pp_click');
					} },
				_react2.default.createElement('i', { className: 'ion-ios-email' }),
				'Request Appointment'
			),
			props.onShowPhoneNumbers && _react2.default.createElement(
				'button',
				{ className: _specialistProfileHeader2.default.solid,
					onClick: function onClick() {
						props.onShowPhoneNumbers();
						(0, _doctifyUtils.fireGTMevent)('' + (window.innerWidth <= 767 ? 'patient_lead_tc_click' : 'lead_submit_reveal'));
						(0, _doctifyUtils.fireGTMevent)('telephone_reveal_' + (window.innerWidth <= 767 ? 'mobile' : 'desktop'));
					} },
				_react2.default.createElement('i', { className: 'ion-ios-telephone' }),
				'Show phone numbers'
			)
		)
	);
};

SpecialistProfileHeader.propTypes = {
	name: require('react').PropTypes.string.isRequired,
	qualifications: require('react').PropTypes.string.isRequired,
	specialty: require('react').PropTypes.string.isRequired,
	profileImage: require('react').PropTypes.string.isRequired,
	specialtyIcon: require('react').PropTypes.string.isRequired,
	averageRating: require('react').PropTypes.number.isRequired,
	totalReviews: require('react').PropTypes.number.isRequired,
	onStarsClick: require('react').PropTypes.func.isRequired,
	onAddReview: require('react').PropTypes.func.isRequired,
	hasRequestAppointment: require('react').PropTypes.bool.isRequired,
	onRequestAppointment: require('react').PropTypes.func.isRequired,
	onShowPhoneNumbers: require('react').PropTypes.func.isRequired,
	className: require('react').PropTypes.string.isRequired,
	isCore: require('react').PropTypes.bool.isRequired,
	isAHG: require('react').PropTypes.bool.isRequired,
	videoConsultation: require('react').PropTypes.bool.isRequired,
	requestAppointmentPractices: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
	networks: require('react').PropTypes.arrayOf(require('react').PropTypes.string).isRequired
};
SpecialistProfileHeader.displayName = 'SpecialistProfileHeader';

SpecialistProfileHeader.defaultProps = {
	profileImage: '',
	specialtyIcon: ''
};

exports.default = SpecialistProfileHeader;


// WEBPACK FOOTER //
// ./components/profile-header/lib/components/specialist-profile-header.js